import { COLUMN_CODE, TableManger, TABLES } from "./TableManger";
import { INPUT_TYPE } from "deskera-ui-library";
import { CONSTANTS } from "../constants/Constant";


export class DealManager {
    static parsePipelineData(records) {
        let pipelines = [];
        const pipelineNameColumnId = TableManger.getColumnId(TABLES.JOB_PIPELINE, COLUMN_CODE.JOB_PIPELINE.NAME);
        const pipelineStageColumnId = TableManger.getColumnId(TABLES.JOB_PIPELINE, COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S);
        // const defaultColumnId = TableManger.getColumnId(TABLES.PIPELINE, COLUMN_CODE.PIPELINE.IS_DEFAULT);
        if (records.data) {
            records.data.forEach(record => {
                pipelines.push({
                    id: record._id,
                    name: record.cells[pipelineNameColumnId] === CONSTANTS.DEFAULT_JOB_PIPELINE ? CONSTANTS.DEFAULT_PIPELINE : record.cells[pipelineNameColumnId],
                    pipelineName: record.cells[pipelineNameColumnId] === CONSTANTS.DEFAULT_JOB_PIPELINE ? CONSTANTS.DEFAULT_JOB_PIPELINE : record.cells[pipelineNameColumnId],
                    // isDefault: record.cells[defaultColumnId],
                    stages: record.cells[pipelineStageColumnId].map(stageId => {
                        return {
                            id: stageId,
                            name: "",
                            candidate: []
                        }
                    })
                })
            });
        }
        return pipelines;
    }
    static putStagesInPipeline(pipelines: any[], records) {
        const stageNameColumnId = TableManger.getColumnId(TABLES.JOB_STAGE, COLUMN_CODE.JOB_STAGE.NAME);
        const stageOrderColumnId = TableManger.getColumnId(TABLES.JOB_STAGE, COLUMN_CODE.JOB_STAGE.ORDER);
        const stageWonColumnId = TableManger.getColumnId(TABLES.JOB_STAGE, COLUMN_CODE.JOB_STAGE.WON_STAGE);
        const stageLostColumnId = TableManger.getColumnId(TABLES.JOB_STAGE, COLUMN_CODE.JOB_STAGE.LOST_STAGE);
        if (pipelines && records.data) {
            pipelines.forEach(pipeline => {
                pipeline.stages.forEach((stage, index) => {
                    let matchedStage = records.data.find(rec => rec._id === stage.id);
                    if(matchedStage) {
                        stage.name = matchedStage.cells[stageNameColumnId];
                        stage.order = matchedStage.cells[stageOrderColumnId];
                        stage.wonIndex = matchedStage.cells[stageWonColumnId] ? index : '';
                        stage.lostIndex = matchedStage.cells[stageLostColumnId] ? index : '';
                    }
                })
            })
        }
    }
    static getDefaultValues(values = {}) {
        return {
            [TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID)]: [0],
            [TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID)]: [0],
            // [TableManger.getColumnId(TABLES.DEAL, COLUMN_CODE.DEAL.VISIBILITY)]: [0],
            // [TableManger.getColumnId(TABLES.DEAL, COLUMN_CODE.DEAL.CLOSING_DATE)]: new Date(),
            // [TableManger.getColumnId(TABLES.DEAL, COLUMN_CODE.DEAL.DEAL_DATE)]: new Date(),
            // [TableManger.getColumnId(TABLES.DEAL, COLUMN_CODE.DEAL.STATUS)]: 0,
            ...values
        }
    }
    static getQuery(type) {
        let personQuery = { "logicalOperator": "and", "conditions": [{ colId: DealManager.getColumnId(COLUMN_CODE.CONTACT.TYPE, TABLES.CONTACT), value: "1", opr: "c" }] }
        let orgQuery = { "logicalOperator": "and", "conditions": [{ colId: DealManager.getColumnId(COLUMN_CODE.CONTACT.TYPE, TABLES.CONTACT), value: "2", opr: "c" }] }

        switch (type) {
          case 'personQuery': return personQuery
          case 'orgQuery': return orgQuery
          default: return
        }
    }
    static contactData = (contacts) => {
        let contactlist = []
        contacts.forEach(contact => {
          let fields = {
              ...contact,
            id: contact._id,
            [COLUMN_CODE.CANDIDATE.NAME]: contact.cells[DealManager.getColumnId(COLUMN_CODE.CANDIDATE.NAME, TABLES.CANDIDATE)],
          }
          contactlist.push(fields)
        })
        return contactlist
      }
    static getColumnId(columnCode, table) {
        return TableManger.getColumnId(table ? table : TABLES.DEAL, columnCode);
    }
    static getDataToUpdate=(data) =>{
        let dealColumns = {};
        TableManger.getTableColumns(TABLES.DEAL).forEach(column => {
            if (column.type === INPUT_TYPE.SELECT || column.type === INPUT_TYPE.MULTI_SELECT) {
                dealColumns[column.id] = column;
            }
        });
        Object.keys(dealColumns).forEach(item => {
            if (data[item]) {
                data[item] = data[item].map(r => dealColumns[item].options.findIndex(op => op.id === r));
            }
        })
    }
    static jobPipelineData = (pipelineData) => {
        let pipelineDataList = []
        pipelineData.forEach(data => {
            let fields = {
                id: data._id,
                [COLUMN_CODE.JOB_PIPELINE.NAME]: data.cells[DealManager.getColumnId(COLUMN_CODE.JOB_PIPELINE.NAME, TABLES.JOB_PIPELINE)] === CONSTANTS.DEFAULT_JOB_PIPELINE ? CONSTANTS.DEFAULT_PIPELINE : data.cells[DealManager.getColumnId(COLUMN_CODE.JOB_PIPELINE.NAME, TABLES.JOB_PIPELINE)],
                [COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S]: data.cells[DealManager.getColumnId(COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S, TABLES.JOB_PIPELINE)],
                type: CONSTANTS.PIPELINE,
                color: "data-grid-badge-color-4",
            }
            pipelineDataList.push(fields)
        })
        return pipelineDataList
    }
}